
export default {
  name: `AdminSignup`,
  data () {
    return {
      confirm_email: '',
      password: '',
      successMsg: null,
      errorMsg: null,
      loading: false,
      isEmailEqual: true,
      confirmEmailError: false,
      passwordError: false
    }
  },
  computed: {
    isDisabled () {
      if (!this.email || !this.password ) {
        return true;
      }
      else if (this.email !== this.confirm_email) {
        return true;
      }

      return false;
    },
    email: {
      get () {
        return this.$store.state.email;
      },
      set (val) {
        this.$store.dispatch('setEmail', val);
      }
    }
  },
  methods: {
    handleConfirmEmailBlur() {
      if (this.email && this.confirm_email && this.email !== this.confirm_email) {
        this.confirmEmailError = 'Email & Confirm Email address must be same!';
      } 
      else {
        this.confirmEmailError = null;
      }
    },
    handlePasswordBlur() {
      if (this.password && this.password.length < 8) {
        this.passwordError = 'Password must be at least 8 characters long';
      }
      else {
        this.passwordError = null;
      }
    },
    login () {
      if (this.loading) {
        return;
      }

      this.loading = true;
      this.errorMsg = null;
      this.successMsg = null;

      const params = {
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        email: this.email,
        confirm_email: this.confirm_email,
        password: this.password
      };

      this.$http.post('/auth/signup', params)
        .then((response) => {
          if (!response.data.error) {
            this.errorMsg = null;
            if (response.data.existing_account) {
              this.successMsg = 'Logging in';
            }
            else {
              this.successMsg = 'Created account ...';
              this.$toast.success('Created account ...');
            }
            
            const afterLoginPath = window.sessionStorage.getItem('afterLoginPath');
            window.sessionStorage.removeItem('afterLoginPath');
            window.setTimeout(() => window.location.href = afterLoginPath || window.appConfig.adminUrl || '/ho/admin', 10);
          }
          else {
            this.errorMsg = response.data.error;
          }
        })
        .catch((error) => {
          console.log(error);
          this.errorMsg = error.toString();
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  mounted () {
    console.log('adminsignup');
  },
  template: `
    <div class="admin-signup-component">      <div class="innblocks-logo logo32 theme"></div>

    <h3>Sign Up</h3>
      <form class="form" v-on:submit.prevent="login">
        <div class="row">
          <label class="label">
            <span class="label-text">Email Address</span>
            <span class="input-wrap">
              <input type="email" v-model="email" />
            </span>
          </label>
        </div>
        <div class="row">
          <label class="label">
            <span class="label-text">Confirm Email Address</span>
            <span class="input-wrap">
              <input 
                type="email"
                v-model="confirm_email"
                v-on:blur="handleConfirmEmailBlur" 
                :class="{'input-error': confirmEmailError}" />
            </span>
          </label>
        </div>
        <div class="row">
          <label class="label">
            <span class="label-text">Password</span>
            <span class="input-wrap">
              <input type="password" v-model="password" 
              v-on:blur="handlePasswordBlur"
              :class="{'input-error': passwordError}" />
            </span>
          </label>
        </div>
        <div class="row success" v-if="successMsg">
            {{successMsg}}
        </div>
        <div class="row error" v-if="errorMsg">
            {{errorMsg}}
        </div>
        <div class="row error" v-if="confirmEmailError">
            {{confirmEmailError}}
        </div>
        <div class="row error" v-if="passwordError">
            {{passwordError}}
        </div>
        <div class="row">
          <button type="submit" :disabled="isDisabled" class="button">
            <span v-if="loading">...</span>
            <span v-if="!loading">Sign Up</span>
          </button>
        </div>
        <div class="row small">
          Already a member? <router-link :to='{name: "login"}'>Login</router-link>
        </div>

        <div class="row x-small">By clicking "Sign up" I agree to Terms of Use, Privacy Policy and to receive electronic communication about my accounts and services per the Agreement</div>
      </form>
    </div>
  `,
};